
    <div
      *ngIf="! standalone"
      class="form-group"
    >
      <fieldmagic-text
        *ngIf="bDisplayLabel"
        purpose="input"
        [content]="label"
        [withRequiredMarker]="withRequiredMarker"
      >
      </fieldmagic-text>
      <ng-container *ngTemplateOutlet="input"></ng-container>
    </div>
    <ng-container
      *ngIf="standalone"
      [ngTemplateOutlet]="input">
    </ng-container>

    <ng-template #input>
      <ng-select
        class="fieldmagic-relate"
        [items]="options$ | async"
        [typeahead]="typeahead$"
        [loading]="loading$ | async"
        [clearable]="clearable"
        [(ngModel)]="selected"
        (ngModelChange)="onModelChange($event)"
        bindLabel="text"
        (focus)="onTouched()"
        appendTo="body"
        placeholder="{{ placeholder | translate }}"
        [class.fieldmagic-input-has-error]="(errors | filled) || (errorneous$ | async)"
        [multiple]="multiple"
        [disabled]="disabled$ | async"
        [bindValue]="bindValue"
        (open)="onOpen()"
      >
        <ng-template ng-option-tmp let-item="item" class="value-text">
          {{ item.text | translate }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-label">{{ item.text | translate }}</span>
          <span
            *ngIf="multiple"
            class="ng-value-icon right selected-close"
            (click)="clear(item)"
          >
            x
          </span>
        </ng-template>
      </ng-select>
      <fieldmagic-input-errors
        *ngIf="errors | filled"
        [errors]="errors"
      ></fieldmagic-input-errors>
    </ng-template>

  